import React from "react";
import {
  Brain,
  Bot,
  Cpu,
  Database,
  LineChart,
  Sparkles,
  Network,
  Shield,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "AI Model Development",
    description:
      "Build custom machine learning models for prediction and classification",
    icon: Brain,
  },
  {
    title: "NLP Solutions",
    description:
      "Develop chatbots, sentiment analysis, and language processing systems",
    icon: Bot,
  },
  {
    title: "Computer Vision",
    description:
      "Create image recognition, object detection, and video analytics",
    icon: Sparkles,
  },
  {
    title: "MLOps & Deployment",
    description:
      "Implement scalable AI infrastructure and model deployment pipelines",
    icon: Cpu,
  },
  {
    title: "Data Engineering",
    description: "Build data pipelines for AI training and real-time inference",
    icon: Database,
  },
  {
    title: "AI Analytics Dashboards",
    description: "Visualize model performance and business insights",
    icon: LineChart,
  },
  {
    title: "AI Integration Services",
    description:
      "Integrate AI capabilities into existing business applications",
    icon: Network,
  },
  {
    title: "Responsible AI",
    description:
      "Ensure ethical AI practices with bias detection and explainability",
    icon: Shield,
  },
];

const STATS = [
  { value: "150+", label: "AI Projects" },
  { value: "50+", label: "ML Models" },
  { value: "95%+", label: "Accuracy" },
  { value: "GPT/LLM", label: "Expertise" },
];

const AIIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="artificial-intelligence"
      industryTitle="Artificial Intelligence"
      industrySubtitle="Solutions"
      heroDescription="Building intelligent AI-native products and platforms that leverage machine learning, natural language processing, and computer vision to transform businesses."
      themeColor="#8b5cf6"
      themeColorLight="#a78bfa"
      themeGradient="linear-gradient(135deg, #4c1d95 0%, #6d28d9 50%, #8b5cf6 100%)"
      HeroIcon={Brain}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1744640326166-433469d102f2?q=80&w=1176&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default AIIndustryPage;
